import { faker } from '@faker-js/faker';
import { Factory } from 'miragejs';

export default Factory.extend({
  catmamaId() {
    return faker.datatype.number(10);
  },

  description() {
    return faker.lorem.paragraph();
  },

  headline() {
    return faker.lorem.word();
  },

  type() {
    const options = ['Series', 'Era', 'Mood'];

    return faker.helpers.arrayElement(options);
  },

  visibleInList() {
    return faker.datatype.boolean();
  },

  cmsLanguageId() {
    return String(
      faker.datatype.number({
        min: 1,
        max: 2,
      }),
    );
  },

  cmsState() {
    return faker.datatype.number({
      min: 1,
      max: 3,
    });
  },

  cmsCreated() {
    return faker.date.past();
  },

  cmsModified() {
    return faker.date.past();
  },

  afterCreate(webSeries, server) {
    if (!webSeries.productFamilies) {
      webSeries.update({
        productFamilies: server.createList('product-family', 3),
      });
    }
  },
});
